(function ($, productFilterData) {
    const productFilters = $('.product-filters-v2')
    if (productFilters.length === 1) {
        productFilters.each(function() {
            productFilters.productFilters('v2');

			var filterElement = $(this);
            var nodeIdentifier = filterElement.data('node-identifier');
			var getFilterOptionsUrl = filterElement.data('get-filter-options-url');
			var moreFiltersUrl = filterElement.data('more-filters-url');
            let loadingHint = filterElement.find('.filter-boxes--loading');
            loadingHint?.addClass('show');

            filterElement.find('.selectpicker').each(function() {
                $(this).on('loaded.bs.select', function (e) {
                    var currentSelect = e.target;

					var data = {
						"filter": $(e.target).attr('name'),
						"filters": productFilterData[nodeIdentifier].filters,
						"searchterm": productFilterData[nodeIdentifier].searchterm,
						"categoryType": productFilterData[nodeIdentifier].categoryType,
						"fulltextSearchType": productFilterData[nodeIdentifier].fulltextSearchType,
                        "sourceNode": nodeIdentifier,
					};
					if (productFilterData[nodeIdentifier].productTaggingNodePath !== null) {
						data["productTaggingNode"] = productFilterData[nodeIdentifier].productTaggingNodePath;
					}

                    $.ajax({
                        url: getFilterOptionsUrl,
                        dataType: 'json',
                        method: 'post',
                        data: data,
                        complete: function (response) {
                            loadingHint?.removeClass('show');
							$.each(response.responseJSON, function (key, option) {
                                if (option.show) {
                                    var opt = document.createElement('option');
                                    opt.value = typeof option.value !== 'undefined' ? option.value : typeof option.uriPathSegment !== 'undefined' ? option.uriPathSegment : key;
                                    opt.innerHTML = option.label;
									opt.classList.add('data-level-' + ((option.label.match(/&nbsp;/g) || []).length / 4).toString());
                                    if (option.selected) {
                                        opt.setAttribute('selected', 'selected');
                                    }

                                    currentSelect.appendChild(opt);
                                }
                            });

                            $(currentSelect).selectpicker('refresh');

                            // workaround to `disableEmptyLists` from FixedFilter.ts directly
                            const wrapper = currentSelect.closest('.dropdown.bootstrap-select');
                            const wrapperFilterCol = currentSelect.closest('.filter-col');
                            const button = wrapper.querySelector('button');

                            if (currentSelect.querySelectorAll('option').length === 0) {
                                wrapperFilterCol.classList.add('d-none', 'filter-has-no-values');
                                wrapper.classList.add('disabled');
                                button.disabled = true;
                            } else {
                                wrapperFilterCol.classList.remove('d-none', 'filter-has-no-values');
                                wrapper.classList.remove('disabled');
                                button.disabled = false;
                            }

                            // adjust dropdown height after options have been loaded
                            if ($(currentSelect).attr('multiple') == 'multiple') {
                                var dropdownMenu = $(currentSelect).parent().find('div.dropdown-menu');
                                var oldMaxHeight = parseInt(dropdownMenu.css('max-height').replace('px', ''));
                                dropdownMenu.css('max-height', (oldMaxHeight + 40) + 'px');
                            }
                        }
                    });
                });
            });

			var data = {
				"firstFilters": firstFilterData[nodeIdentifier],
				"filters": productFilterData[nodeIdentifier].filters,
				"searchterm": productFilterData[nodeIdentifier].searchterm,
				"categoryType": productFilterData[nodeIdentifier].categoryType,
				"fulltextSearchType": productFilterData[nodeIdentifier].fulltextSearchType,
                "sourceNode": nodeIdentifier,
			};
			if (productFilterData[nodeIdentifier].productTaggingNodePath !== null) {
				data["productTaggingNode"] = productFilterData[nodeIdentifier].productTaggingNodePath;
			}
			$.ajax({
				url: moreFiltersUrl,
				dataType: 'html',
				method: 'get',
				data: data,
				complete: function (response) {
                    loadingHint?.removeClass('show');
					filterElement.find('.show-more-filters').show();
					filterElement.find('.more-filters').replaceWith(response.responseText);
                    productFilters.data('plugin_productFilters').initializeSelects();
                    productFilters.data('plugin_productFilters').initializeShowMoreFiltersButton();
                    productFilters.data('plugin_productFilters').preventPriceDropdownToggle();
				}
			});
        });
    }
})(jQuery, typeof productFilterData !== 'undefined' ? productFilterData : {});
